module.exports = __webpack_public_path__ + "static/img/downloadApp.630435e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/downloadApp.png
// module id = Z4Ml
// module chunks = 89